import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  loading: false
});

// src: null,
// widthIn: null,
// heightIn: null,
// posX: null,
// poxY: null

const hangings = createReducer(getDefaultState(), {
  [Constants.hangings.load]: () => ({ loading: true }),
  [Constants.hangings.loaded]: (state, { hangingMarks }) => ({ hangingMarks, loading: false }),
  [Constants.hangings.update]: (state, {
    first, second, kind, isAdd
  }) => {
    const { hangingMarks } = state;
    let newMarks = [...hangingMarks];
    if (isAdd) {
      newMarks.push({ first, second, kind });
    } else {
      const index = hangingMarks.findIndex((m) => (
        ((m.first === first && m.second === second) || (m.first === second && m.second === first))
        && m.kind === kind
      ));
      newMarks[index]  = null;
      newMarks = newMarks.filter(m => !!m);
    }
    return {
      ...state,
      hangingMarks: newMarks
    };
  },
  [Constants.hangings.reset]: (state) => ({
    ...state,
    hangingMarks: []
  }),
  [Constants.hangings.saving]: (state) => ({
    ...state,
    loading: true
  }),
  [Constants.hangings.saved]: (state, { hangingMarks }) => ({
    ...state,
    loading: false,
    hangingMarks
  })
});

export default hangings;
